import React from 'react';

// COMPONENTS
import PropTypes from 'prop-types';
import Search from '../../Framework/Components/Search';
import Text from '../../Framework/Components/Form/TextInput';

const CategorySearch = ({ categoryType, ...props }) => (
    <Search {...props}>
        <Text name="type" value={categoryType} type="hidden" />
        <Text name="name" />
    </Search>
);

CategorySearch.propTypes = {
    categoryType: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    entity: PropTypes.object.isRequired,
};

export default CategorySearch;
